import app from 'ampersand-app'
import { useRef, useState } from 'preact/hooks'
import { Modal, ModalPanel } from '../modal/modal'
import { PreactView } from '../preact-view'
import { DispatchForm } from './dispatch-form'
import * as styles from './dispatch-form.module.css'
import { DispatchFormTablet } from './dispatch-form-tablet'
import { useTabletMode } from './toggle-tablet-mode'

function DispatchButton() {
  const [isOpen, setIsOpen] = useState(false)
  const initialFocus = useRef<HTMLSelectElement>(null)
  const [isTabletMode, setIsTabletMode] = useTabletMode(
    'enable-touch-dispatch-form'
  )

  return (
    <>
      <button
        type='button'
        className='pure-button pure-button-primary btn-round dispatch'
        onClick={() => setIsOpen(true)}
      >
        <i className='ion-paper-airplane' />
      </button>

      <Modal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        initialFocus={!app.isMobile ? initialFocus : undefined}
      >
        {isTabletMode ? (
          <ModalPanel className={styles.modalPanelTablet}>
            <DispatchFormTablet
              onClose={() => setIsOpen(false)}
              isTabletMode={isTabletMode}
              setIsTabletMode={setIsTabletMode}
            />
          </ModalPanel>
        ) : (
          <ModalPanel>
            <DispatchForm
              onClose={() => setIsOpen(false)}
              initialFocus={initialFocus}
              isTabletMode={isTabletMode}
              setIsTabletMode={setIsTabletMode}
            />
          </ModalPanel>
        )}
      </Modal>
    </>
  )
}

export const DispatchButtonView = PreactView.extend({
  component: DispatchButton
})
